<template>
  <div class="recycle-container">
    <div class="recycle-header">
      <h3>回收站</h3>
      <el-button type="danger" plain @click="clearAll" :disabled="recycleList.length === 0">
        清空回收站
      </el-button>
    </div>
    
    <el-tabs v-model="activeTab">
      <el-tab-pane label="项目" name="projects">
        <el-table :data="recycledProjects" v-loading="loading" border>
          <el-table-column prop="name" label="项目名称" min-width="200"></el-table-column>
          <el-table-column prop="code" label="项目代号" width="150"></el-table-column>
          <el-table-column prop="deletedTime" label="删除时间" width="180"></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="{ row }">
              <el-button type="text" @click="restore(row, 'project')">恢复</el-button>
              <el-button type="text" class="text-danger" @click="permanentDelete(row, 'project')">彻底删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      
      <el-tab-pane label="问卷" name="forms">
        <el-table :data="recycledForms" v-loading="loading" border>
          <el-table-column prop="name" label="问卷名称" min-width="200"></el-table-column>
          <el-table-column prop="projectName" label="所属项目" width="150"></el-table-column>
          <el-table-column prop="type" label="类型" width="100">
            <template slot-scope="{ row }">
              {{ getFormTypeName(row.type) }}
            </template>
          </el-table-column>
          <el-table-column prop="deletedTime" label="删除时间" width="180"></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="{ row }">
              <el-button type="text" @click="restore(row, 'form')">恢复</el-button>
              <el-button type="text" class="text-danger" @click="permanentDelete(row, 'form')">彻底删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    
    <div class="recycle-tip">
      <i class="el-icon-info"></i>
      回收站中的数据将在 30 天后自动清除
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecycleBin',
  
  data() {
    return {
      loading: false,
      activeTab: 'projects',
      recycledProjects: [],
      recycledForms: []
    }
  },
  
  computed: {
    recycleList() {
      return this.activeTab === 'projects' ? this.recycledProjects : this.recycledForms
    }
  },
  
  mounted() {
    this.loadRecycleData()
  },
  
  methods: {
    async loadRecycleData() {
      this.loading = true
      try {
        // TODO: 调用回收站API
        // const res = await getRecycleBin()
        // this.recycledProjects = res.data.projects || []
        // this.recycledForms = res.data.forms || []
        this.recycledProjects = []
        this.recycledForms = []
      } catch (e) {
        console.error('加载回收站失败', e)
      } finally {
        this.loading = false
      }
    },
    
    getFormTypeName(type) {
      const map = { 1: '问卷', 2: '考试', 3: '报名' }
      return map[type] || '问卷'
    },
    
    restore(row, type) {
      this.$confirm(`确定恢复该${type === 'project' ? '项目' : '问卷'}吗？`, '提示')
        .then(async () => {
          // TODO: await restoreItem(row.id, type)
          this.$message.success('恢复成功')
          this.loadRecycleData()
        })
        .catch(() => {})
    },
    
    permanentDelete(row, type) {
      this.$confirm(
        `确定彻底删除该${type === 'project' ? '项目' : '问卷'}吗？此操作不可恢复！`,
        '警告',
        { type: 'warning', confirmButtonClass: 'el-button--danger' }
      ).then(async () => {
        // TODO: await permanentDeleteItem(row.id, type)
        this.$message.success('已彻底删除')
        this.loadRecycleData()
      }).catch(() => {})
    },
    
    clearAll() {
      this.$confirm('确定清空回收站吗？此操作不可恢复！', '警告', {
        type: 'warning',
        confirmButtonClass: 'el-button--danger'
      }).then(async () => {
        // TODO: await clearRecycleBin()
        this.$message.success('回收站已清空')
        this.loadRecycleData()
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.recycle-container {
  padding: 0;
}

.recycle-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  
  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 500;
  }
}

.text-danger {
  color: #f56c6c;
}

.recycle-tip {
  margin-top: 20px;
  padding: 12px 16px;
  background: #f4f4f5;
  border-radius: 4px;
  color: #909399;
  font-size: 13px;
  
  i {
    margin-right: 6px;
  }
}
</style>
